<template>
  <div class="drawer">
    <div class="drawer-container">
      <div class="drawer-content">
        <el-form ref="rentForm" :model="rent" class="box" label-width="100px">
          <fieldset class="mgb15">
            <legend>{{ $t("text.baseInfo") }}</legend>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('rent.serialNo')">
                  {{ rent.serialNo }}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('bargain.amount')">{{
                  rent.amount | currency
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('text.createAt')">{{
                  rent.createAt
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('text.owner')">{{
                  rent.ownerName
                }}</el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item :label="$t('rent.rentAt')"
                  >{{ rent.startAt }} ～ {{ rent.endAt }}</el-form-item
                >
              </el-col>
            </el-row>
          </fieldset>
          <el-row :gutter="20">
            <el-col :span="16">
              <fieldset>
                <legend>{{ $t("customer.customerInfo") }}</legend>
                <el-row>
                  <el-col :span="12">
                    <el-form-item :label="$t('bargain.customerName')">{{
                      rent.customerName
                    }}</el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item :label="$t('bargain.customerPhone')">{{
                      rent.customerPhone
                    }}</el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item :label="$t('bargain.customerAddress')">
                      <span v-if="rent.customerCountry != null">{{
                        $t("countries." + rent.customerCountry)
                      }}</span>
                      {{ rent.customerProvince }}{{ rent.customerCity
                      }}{{ rent.customerAddress }}
                      <small v-if="rent.customerZipcode != null"
                        >({{ rent.customerZipcode }})</small
                      >
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
            </el-col>
            <el-col :span="8">
              <fieldset>
                <legend>{{ $t("text.remark") }}</legend>
                <raw-html :content="rent.remark" />
              </fieldset>
            </el-col>
          </el-row>
          <fieldset v-if="Permit.canActions('rentManage')" class="mgb15">
            <legend>{{ $t("bargain.paymentInfo") }}</legend>
            <vxe-table
              :data="rent.payments"
              size="small"
              :scroll-y="{ enabled: false }"
            >
              <vxe-table-column field="total" :title="$t('payment.total')">
                <template v-slot="{ row }">
                  {{ row.total | currency }}
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="payMethodName"
                :title="$t('payment.payMethod')"
              ></vxe-table-column>
              <vxe-table-column
                field="paidAt"
                :title="$t('payment.paidAt')"
              ></vxe-table-column>
              <vxe-table-column
                field="ownerName"
                :title="$t('payment.ownerName')"
              ></vxe-table-column>
              <vxe-table-column field="voucher" :title="$t('payment.voucher')">
                <template v-slot="{ row }">
                  <thumbnail-text :srcs="row.voucher" />
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="explain"
                :title="$t('payment.explain')"
              ></vxe-table-column>
              <vxe-table-column
                v-if="Permit.canActionsChargeEdition('rentManage')"
                field="action"
                :title="$t('text.action')"
              >
                <template v-slot="{ row, rowIndex }">
                  <el-button
                    v-if="row.payMethodId != -1 && row.payMethodId != 0"
                    type="text"
                    size="mini"
                    @click="editPayment(row, rowIndex)"
                    >{{ $t("text.edit") }}</el-button
                  >
                  <el-button
                    type="text"
                    size="mini"
                    @click="deletePayment(row, rowIndex)"
                    >{{ $t("text.delete") }}</el-button
                  >
                </template>
              </vxe-table-column>
            </vxe-table>
          </fieldset>
        </el-form>
      </div>
    </div>
    <!-- 编辑收款 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editPaymentDF"
      width="30%"
      destroy-on-close
    >
      <el-form
        ref="editPaymentObjForm"
        :model="editPaymentObj"
        label-width="60px"
      >
        <el-form-item
          :label="$t('payment.total')"
          :prop="'total'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('payment.total')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="editPaymentObj.total"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('payment.payMethod')"
          :prop="'payMethodId'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('payment.payMethod')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select v-model="editPaymentObj.payMethodId" clearable filterable>
            <el-option
              v-for="payMethod in payMethods"
              :key="payMethod.id"
              :label="payMethod.name"
              :value="payMethod.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('payment.paidAt')"
          :prop="'paidAt'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('payment.paidAt')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-date-picker
            v-model="editPaymentObj.paidAt"
            type="date"
            style="width: 100%"
            :picker-options="pickerOptionsSevenDays"
          />
        </el-form-item>
        <el-form-item :label="$t('payment.explain')" :prop="'explain'">
          <el-input v-model="editPaymentObj.explain" />
        </el-form-item>
        <el-form-item :label="$t('payment.voucher')" :prop="'voucher'">
          <dropzone v-model="editPaymentObj.voucher" multiple />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="editPaymentDoing"
          size="small"
          @click="editPaymentSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editPaymentDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import ThumbnailText from "@/components/ThumbnailText";
import Dropzone from "@/components/Dropzone";
import RawHtml from "@/components/RawHtml";
import Payment from "@/api/payment.js";
import PayMethod from "@/api/payMethod.js";
import Rent from "@/api/rent.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: {
    ThumbnailText,
    RawHtml,
    Dropzone,
  },
  data() {
    return {
      rent: {},
      //编辑收款
      pickerOptionsSevenDays: {
        disabledDate(time) {
          const curDate = new Date().getTime();
          const day = 90 * 24 * 3600 * 1000;
          const threeMonths = curDate - day;
          return time.getTime() > Date.now() || time.getTime() < threeMonths;
        },
      },
      editPaymentDF: false,
      payMethods: [],
      currentRowIdx: null,
      row: null,
      editPaymentObj: {
        total: null,
        payMethodId: null,
        payMethodName: null,
        explain: null,
        voucher: null,
        paidAt: null,
      },
      editPaymentDoing: false,
    };
  },
  mounted() {
    // 根据id请求bargain
  },
  created() {
    const self = this;
    self.loadingStart();
    Rent.findById(self.id).then(function (res) {
      if (res.data.code === 200) {
        self.rent = res.data.entity;
      } else {
        self.sysError();
      }
      self.loadingEnd();
    });
  },
  methods: {
    getRent() {
      const self = this;
      self.loadingStart();
      Rent.findById(self.id).then(function (res) {
        if (res.data.code === 200) {
          self.rent = res.data.entity;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },
    // 删除收款
    deletePayment(row, rowIndex) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        Payment.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.getRent();
            self.$emit("updateInfo");
          } else {
            self.sysError();
          }
        });
      }
    },
    // 编辑收款
    editPayment(row, rowIndex) {
      const self = this;
      self.currentRowIdx = rowIndex;
      self.row = row;
      self.editPaymentObj.total = row.total;
      self.editPaymentObj.explain = row.explain;
      self.editPaymentObj.voucher = row.voucher;
      self.editPaymentObj.paidAt = row.paidAt;
      PayMethod.findByTypes({ types: PayMethod.saleTypes }).then(function (
        res
      ) {
        if (res.status === 200) {
          self.payMethods = res.data;
          if (self.payMethods.find((p) => p.id == row.payMethodId) != null) {
            self.editPaymentObj.payMethodId = row.payMethodId;
            self.editPaymentObj.payMethodName = row.payMethodName;
          }
          self.editPaymentDF = true;
        } else {
          self.sysError();
        }
      });
    },
    editPaymentSubmit() {
      const self = this;
      this.$refs.editPaymentObjForm.validate((valid) => {
        if (valid) {
          if (!Util.regexQuantity(self.editPaymentObj.total)) {
            self.$message({
              message: self.$t("rules.regex", [self.$t("payment.total")]),
              type: "warning",
            });
            return;
          }

          self.editPaymentObj.payMethodName = self.payMethods.find(
            (p) => p.id === this.editPaymentObj.payMethodId
          ).name;
          self.editPaymentObj.paidAt =
            Util.formatDate(self.editPaymentObj.paidAt) + " 00:00:00";
          self.editPaymentDoing = true;
          Payment.update(self.row.id, self.editPaymentObj).then(function (res) {
            if (res.status === 200) {
              self.rent.payments[self.currentRowIdx].total =
                self.editPaymentObj.total;
              self.rent.payments[self.currentRowIdx].payMethodName =
                self.editPaymentObj.payMethodName;
              self.rent.payments[self.currentRowIdx].explain =
                self.editPaymentObj.explain;
              self.rent.payments[self.currentRowIdx].voucher =
                self.editPaymentObj.voucher;
              self.rent.payments[self.currentRowIdx].paidAt =
                self.editPaymentObj.paidAt;
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.$emit("updateInfo");
              self.editPaymentDoing = false;
              self.editPaymentDF = false;
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>